var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1113 3.79544C13.3518 2.92836 12.9332 1.81481 12.9335 0.662109H9.50017V14.4399C9.47369 15.1855 9.15892 15.8917 8.62213 16.4098C8.08535 16.9279 7.36845 17.2176 6.6224 17.2177C5.04462 17.2177 3.73351 15.9288 3.73351 14.3288C3.73351 12.4177 5.57795 10.9843 7.47795 11.5732V8.06211C3.64462 7.551 0.289062 10.5288 0.289062 14.3288C0.289062 18.0288 3.35573 20.6621 6.61128 20.6621C10.1002 20.6621 12.9335 17.8288 12.9335 14.3288V7.33989C14.3257 8.33972 15.9972 8.87616 17.7113 8.87322V5.43989C17.7113 5.43989 15.6224 5.53989 14.1113 3.79544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.5702d7baa2fce0488d7470e7c7ba66b0.svg";
export { ForwardRef as ReactComponent };